import React, { useState, useEffect } from 'react'
import { dataTableRender } from '../components/functions'
import api from '../components/api'
import Member from '../modals/member'
import axios from 'axios'

const API_Membros = () => {


    const [resultado, setResultado] = useState()
    const [member_id, setMember_id] = useState()


    async function carregaDados() {




        await api.get('membersData/1/1/2000/0').then((result) => {

            //console.log(result)
            

            setResultado(result.data.members.map((rs) => 

                <tr style={{ cursor: 'pointer'}} data-toggle="modal" data-target="#modalMember" onClick={() => setMember_id(rs.member_id)}>

                    <td>
                        {rs.cnpj}
                    </td>
                    <td>
                        {rs.corporateName}
                    </td>
                    <td>
                        {rs.tradeName}
                    </td>
                    <td>
                        {rs.state}
                    </td>
                    <td>
                        {rs.climateChallengeYears.toString().replaceAll(',',', ')}
                    </td>
                    <td>
                        {rs.wasteChallengeYears.toString().replaceAll(',',', ')}
                    </td>
                    <td>
                        {rs.energyChallengeYears.toString().replaceAll(',',', ')}
                    </td>
                    <td>
                        {rs.procurementChallengeYears.toString().replaceAll(',',', ')}
                    </td>
                    <td style={{ backgroundColor: rs.status == 'Active' ? '#b6fadd' : '#fab6b6'}}>
                        {rs.status}
                    </td>


                </tr>
               

            ))

            dataTableRender('tabelaMembrosInstitucionais', 1, 'asc')

        }).catch((err) => {

            console.log(err)

            console.log(err.response)

        })


    }


    function atualizaMembros() {



        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma atualizar as informações dos membros da API?',
		    buttons: {
		        Sim: function () {



                    axios.post('https://api2.hospitaissaudaveis.org/atualizaMembros').then((result) => {

                        if (result.data.alerta == 'ok') {

                            window.toastr.success('Atualizado com sucesso!')

                        }

                    }).catch((err) => {

                        console.log(err.response)

                    })

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


        


    }


    useEffect(() => {

        carregaDados()

    }, [])


    return (

        <div>

            <div class="row">
                
                <div class="col-md-12">

                                        
                    <button type="button" class="btn btn-info" onClick={() => atualizaMembros()}>Atualizar</button>&nbsp;

                    <br/><br/>

                </div>
                <div class="col-md-12">


                    <div className="table-responsive">
                        <table id="tabelaMembrosInstitucionais" className="table table-bordered table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>CNPJ</th>
                                    <th>Corporate Name</th>
                                    <th>Trade Name</th>
                                    <th>State</th>
                                    <th>Climate Years</th>
                                    <th>Waste Years</th>
                                    <th>Energy Years</th>
                                    <th>Procurement Years</th>
                                    <th>Status</th>
                                                                                
                                </tr>
                            </thead>
                            <tbody>
                                {resultado}
                            </tbody>
                            
                        </table>
                    </div>


                </div>

            </div>


            <Member member_id={member_id} />


        </div>
    )

}


export default API_Membros